import React from 'react'
import cn from 'classnames'
import { Tooltip } from 'shared/ui'
import { check as DoneIcon, redo as ClosedIcon } from 'assets/icons/groove/v2'

const StateButton = React.memo(({ openOrCloseConversation, isCloseable }) => {
  return (
    <div className="state">
      <a
        className={cn('menu-button', { closable: isCloseable })}
        onClick={openOrCloseConversation}
      >
        {isCloseable ? (
          <Tooltip position="bottom" tooltip={'Close [shift-c]'}>
            <DoneIcon />
          </Tooltip>
        ) : (
          <Tooltip position="bottom" tooltip={'Reopen [shift-o]'}>
            <ClosedIcon />
          </Tooltip>
        )}
      </a>
    </div>
  )
})

export default StateButton
